var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89805 10.7639L4 8L3.10194 10.7639H0.19577L2.54691 12.4721L1.64886 15.2361L4 13.5279L6.35114 15.2361L5.45308 12.4721L7.80422 10.7639H4.89805ZM6.26538 11.2639H4.53478L4 9.61803L3.46521 11.2639H1.73461L3.1347 12.2812L2.59991 13.9271L4 12.9098L5.40008 13.9271L4.8653 12.2812L6.26538 11.2639Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8L20.8981 10.7639H23.8042L21.4531 12.4721L22.3511 15.2361L20 13.5279L17.6489 15.2361L18.5469 12.4721L16.1958 10.7639H19.1019L20 8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8981 10.7639L20 8L19.1019 10.7639H16.1958L18.5469 12.4721L17.6489 15.2361L20 13.5279L22.3511 15.2361L21.4531 12.4721L23.8042 10.7639H20.8981ZM22.2654 11.2639H20.5348L20 9.61803L19.4652 11.2639H17.7346L19.1347 12.2812L18.5999 13.9271L20 12.9098L21.4001 13.9271L20.8653 12.2812L22.2654 11.2639Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8981 10.7639L12 8L11.1019 10.7639H8.19577L10.5469 12.4721L9.64886 15.2361L12 13.5279L14.3511 15.2361L13.4531 12.4721L15.8042 10.7639H12.8981ZM14.2654 11.2639H12.5348L12 9.61803L11.4652 11.2639H9.73461L11.1347 12.2812L10.5999 13.9271L12 12.9098L13.4001 13.9271L12.8653 12.2812L14.2654 11.2639Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.42303497692eed8d0c5ee73c16c3ae25.svg";
export { ForwardRef as ReactComponent };